import React from 'react';

export default translationsStore => ({
  width: '60px',
  sorter: (a, b) => a.car.kmPerDay - b.car.kmPerDay,
  className: 'kmPerDay',
  title: (
    <span>
      <div>{translationsStore.translate('lead.table.column.mainKmDay.km')}</div>
      <div>{translationsStore.translate('lead.table.column.mainKmDay.day')}</div>
    </span>
  ),
  dataIndex: 'car.kmPerDay',
  render: text => (
    <div style={{ fontWeight: 'bold', color: `${text > 50 ? 'var(--red-dtc-color)' : text > 16 ? 'var(--orange-dtc-color)' : 'var(--green-ok)'}` }}>{Math.round(text)}</div>
  )
});
